module.exports = __webpack_public_path__ + "img/riekkola_sauna4.077f7f79.jpg";